import { defineStore } from 'pinia';

export const useSessionStore = defineStore('session', {
  state: () => ({
    intervalId: null,
  }),
  actions: {
    startInterval(callback, interval) {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(callback, interval);
    },
    stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  },
});
